const EVENTS = {
    PAYPANGEA_WIDGET_INITIALISED: 'PAYPANGEA_WIDGET_INITIALISED',
    PAYPANGEA_WIDGET_OPEN: 'PAYPANGEA_WIDGET_OPEN',
    PAYPANGEA_WIDGET_CLOSE_REQUEST: 'PAYPANGEA_WIDGET_CLOSE_REQUEST',
    PAYPANGEA_WIDGET_CLOSE: 'PAYPANGEA_WIDGET_CLOSE',
}

export default EVENTS;